/**
 * Created by Ning Jiang on 2021-06-18.
 */

import {gsap, TimelineLite} from "gsap";
import {MathHelper} from "../../../../core/utils/MathHelper";
import {OktoberfestLayers, Layers} from "../../../view/OktoberfestLayers";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/text/TextStyleOptions";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class InitialWinCountUp extends PIXI.Container {
    protected _countUp: PIXI.Text;
    protected _bigWinText: PIXI.Text;
    private _endingScale: number = 1;

    constructor() {
        super();

        const winAmountDisplayNumbersTextStyle: TextStyleOptions = {
            fontFamily: "Atreyu",
            fontSize: "82.5px",
            fill: "#FFF864",
            stroke: "#5C521F",
            strokeThickness: 2,
            dropShadow: true,
            dropShadowColor: "#3B3412",
            dropShadowAngle: 0.872665,
            dropShadowDistance: 5,
            padding: 20
        };
        this._countUp = new PIXI.Text("000", winAmountDisplayNumbersTextStyle);
        this._bigWinText = new PIXI.Text("", winAmountDisplayNumbersTextStyle);
        this._countUp.visible = false;
        this._bigWinText.visible = false;
        this._bigWinText.anchor.set(0.5, 0.1);
        this._countUp.anchor.set(0.5, 0.1);
        this.addChild(this._countUp, this._bigWinText);
        this.position.set(360, 360);
        this._countUp.position.set(0, -100);
        this._bigWinText.position.set(0, -200);
        OktoberfestLayers.getLayer(Layers.WIN_COUNT_UP)?.addChild(this);
    }

    public getCountUpAnimation(from: number, to: number, duration: number, multiplier: number): TimelineLite {
        OktoberfestLayers.getLayer(Layers.WIN_COUNT_UP)!.visible = true;
        this._countUp.position.set(0, -100);
        this._bigWinText.position.set(0, -200);
        const baseToNumber = multiplier === 1 ? to : MathHelper.roundToDecimals(to / multiplier, 2);
        const tl = gsap.timeline();
        tl.add([
            () => {
                this.updateWinNumbers(to);
                this._countUp.scale.set(1);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                if (duration > 0.01) {
                    // play count up sound.
                }
            },
        ]);
        // ending stay
        // tl.add(this.stay(multiplier));
        tl.add(() => {
            this.remove()
        }, 1.5);

        return tl;
    }

    public remove(): TimelineLite {
        const tl = gsap.timeline();
        if (this._countUp.visible) {
            tl.add(gsap.to([this._countUp, this._bigWinText], {
                duration: 0.5,
                alpha: 0,
                y: -( NolimitApplication.screenBounds.width * 0.5 ),
                ease: `power2.in`
            }), `+=0.2`); // stay a short while after count up

            tl.add(() => {
                this._countUp.y = 0;
                this._bigWinText.y = 0;
                this._countUp.scale.set(1, 1);
                this._bigWinText.scale.set(1, 1);
                this._countUp.visible = false;
                this._bigWinText.visible = false;
            });
        }

        return tl;
    }

    public setText(value: string): void {
        this._bigWinText.text = value;
        this._bigWinText.visible = true;
        this._bigWinText.alpha = 1;
    }

    private stay(multiplier: number): TimelineLite {
        const tl = gsap.timeline();
        tl.add(gsap.to(this._countUp.scale, {
            duration: 0.5,
            x: this.getScale(multiplier) * 1.05,
            y: this.getScale(multiplier) * 1.05,
            ease: `elastic.out(2, 0.75)`
        }));
        tl.add(
            gsap.to(this._countUp.scale, {
                duration: 0.5,
                x: this._endingScale,
                y: this._endingScale,
                ease: `elastic.out(1, 1)`
            }));
        return tl;
    }

    private updateWinNumbers(win: number) {
        this._countUp.text = SlotGame.apiPlugin.currency.format(win);
    }

    private getScale(multiplier: number): number {
        return 1 + ( multiplier - 1 ) * 0.1;
    }
}
